export enum DataHooks {
  WRAPPER = 'page-title-wrapper',
  TITLE = 'page-title',
}
